export const environment = {
  production: false,
  _accessToken : 'w1h9-xlOaAyZEygg2kPp6aOoMODgXxJ5z3wJK7Et'

};
